import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { FetchManagerExpenseApprovalType } from "../../../domain/models/expense-dashboard/fetch-manager-expense-approval";
import { FetchManagerExpenseApproval } from "../../../domain/useages/expense-dashboard/fetch-manager-expense-approval";
import { RemoteFetchManagerExpenseApproval } from "../../../data/usecases/expense-dashboard/remote-fetch-manager-expense-approval";

export interface FetchManagerExpenseApprovalInterface {
    FetchManagerExpenseApproval: FetchManagerExpenseApprovalType;
    FetchManagerExpenseApprovalState: FetchState;
    fetchManagerExpenseApproval: Function;
}

const initialStates = {
    FetchManagerExpenseApproval: {} as FetchManagerExpenseApprovalType,
    FetchManagerExpenseApprovalState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchManagerExpenseApprovalSlice: StateCreator<
FetchManagerExpenseApprovalInterface
> = (set) => ({
  ...initialStates,
  fetchManagerExpenseApproval: async (params: FetchManagerExpenseApproval.Params) => {
  
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchManagerExpenseApproval = new RemoteFetchManagerExpenseApproval(
      `${BASE_URL}${Endpoints.FETCH_MANAGER_EXPENSE_APPROVAL}`,
      axiosHttpClient
    );

    set(() => ({ FetchManagerExpenseApprovalState: FetchState.LOADING }));
    let result = await remoteFetchManagerExpenseApproval.fetch(params);
    return result;
  },
});
